export type TSearchConfigurationsResponse = {
  content: {
    customerId: string;
    isAuthorized: boolean;
    configurations: {
      id: string;
      createdDate: string;
      projectConfigurationParameters: { key: string; value: string }[];
    }[];
  }[];
};

export enum ProjectConfigurationParametersEnum {
  length = 'length',
  layingType = 'layingType',
  width = 'width',
  area = 'area',
  roomType = 'roomType',
}

export enum ParametersEnum {
  length = 'length',
  width = 'width',
  area = 'area',
}

export type TInputParams = Array<ParametersEnum>;

export enum RoomType {
  KITCHEN = 'kitchen',
  BATHROOM = 'bathroom',
  LIVING_ROOM = 'living_room',
  BEDROOM = 'bedroom',
  HALLWAY = 'hallway',
  NURSERY = 'nursery',
  OFFICE_SPACE = 'office_space',
}
